import React from "react";
import { Flex } from "@jsq/ds/core";
import * as styles from "./styles_vanilla.css";

type RiskLevel = "risk01" | "risk23" | "risk45" | "risk67" | "risk89" | "risk10Plus";

export const RiskLegend: React.FC = () => {
  const riskLevels: Array<{ range: string; key: RiskLevel; colorClass: string }> = [
    { range: "0-1", key: "risk01", colorClass: styles.risk01 },
    { range: "2-3", key: "risk23", colorClass: styles.risk23 },
    { range: "4-5", key: "risk45", colorClass: styles.risk45 },
    { range: "6-7", key: "risk67", colorClass: styles.risk67 },
    { range: "8-9", key: "risk89", colorClass: styles.risk89 },
    { range: "10+", key: "risk10Plus", colorClass: styles.risk10Plus },
  ];

  return (
    <Flex data-testid="risk-legend-container">
      {riskLevels.map((level) => (
        <Flex
          key={level.range}
          className={`${styles.legendItem} ${level.colorClass}`}
          data-testid="legend-item"
        >
          <span className={styles.legendText[level.key]}>{level.range}</span>
        </Flex>
      ))}
    </Flex>
  );
};
